export default __webpack_public_path__ + "static/media/no-suppliers-icon.8f37903a.svg";